import React from 'react';

export default class OneColumn extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        var styles = {
            cls1: {
                fill: 'rgba(0,0,0,0.05)'
            },
            cls2: {
                fill: '#fff'
            },
            cls3: {
                fill: 'rgba(0,0,0,0.2)'
            },
            cls4: {
                fill: 'rgba(0,0,0,0.1)'
            },
            cls5: {
                filter: 'url(#Rectangle_158)'
            }
        }
        return <svg id="Group_266" data-name="Group 266" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" className="svg-holder" viewBox="16868 6582 253 257">
            <defs>
                <filter id="Rectangle_158" x="16879" y="6588" width="230" height="251" filterUnits="userSpaceOnUse">
                    <feOffset dy="-5" />
                    <feGaussianBlur stdDeviation="3" result="blur" />
                    <feFlood floodOpacity="0.039" />
                    <feComposite operator="in" in2="blur" />
                    <feComposite in="SourceGraphic" />
                </filter>
            </defs>
            <rect id="Rectangle_157" data-name="Rectangle 157" className="outer" width="253" height="253" rx="3" transform="translate(16868 6582)" />
            <g style={styles.cls5} transform="matrix(1, 0, 0, 1, 0, 0)">
                <path id="Rectangle_158-2" data-name="Rectangle 158" style={styles.cls2} d="M3,0H209a3,3,0,0,1,3,3V233a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3A3,3,0,0,1,3,0Z" transform="translate(16888 6602)" />
            </g>
            <rect id="Rectangle_159" data-name="Rectangle 159" className="inner" width="192" height="20" rx="3" transform="translate(16898 6612)" />
            <rect id="Rectangle_163" data-name="Rectangle 163" className="inner" width="192" height="60" rx="3" transform="translate(16898 6700)" />
            <rect id="Rectangle_160" data-name="Rectangle 160" style={styles.cls4} width="192" height="4" rx="2" transform="translate(16898 6652)" />
            <rect id="Rectangle_161" data-name="Rectangle 161" style={styles.cls4} width="192" height="4" rx="2" transform="translate(16898 6664)" />
            <rect id="Rectangle_162" data-name="Rectangle 162" style={styles.cls4} width="128" height="4" rx="2" transform="translate(16898 6676)" />
            <rect id="Rectangle_164" data-name="Rectangle 164" style={styles.cls4} width="192" height="4" rx="2" transform="translate(16898 6779)" />
            <rect id="Rectangle_168" data-name="Rectangle 168" style={styles.cls4} width="192" height="4" rx="2" transform="translate(16898 6815)" />
            <rect id="Rectangle_166" data-name="Rectangle 166" style={styles.cls4} width="192" height="4" rx="2" transform="translate(16898 6803)" />
            <rect id="Rectangle_165" data-name="Rectangle 165" style={styles.cls4} width="192" height="4" rx="2" transform="translate(16898 6791)" />
            <rect id="Rectangle_167" data-name="Rectangle 167" style={styles.cls4} width="192" height="4" rx="2" transform="translate(16898 6827)" />
        </svg>

    }
}